import * as React from 'react';
import clsx from 'clsx';
import { Link } from 'gatsby';
import styles from './imb.module.css';

const ICO = [
  require('./img/ico-01.svg'),
  require('./img/ico-02.svg'),
  require('./img/ico-03.svg'),
  require('./img/ico-04.svg'),
];

interface LinkItem {
  title: string;
  to: string;
}

interface Item {
  img?: string;
  title: string;
  text?: string;
  list?: ReadonlyArray<string | LinkItem>;
}

interface Props {
  list: Item[];
  className?: string;
}

function RenderItem({ img, title, text, list, idx }: Item & { idx: number }) {
  return (
    <div className={styles.content}>
      <img src={img || ICO[idx]} className={styles.img} alt="" />
      <h4 className={styles.title}>{title}</h4>
      {text && <p className={styles.text}>{text}</p>}
      {list && list.length ? (
        <ul className={styles.list}>
          {list.map((e) =>
            typeof e === 'string' ? (
              <li key={e} className={styles.item}>
                {e}
              </li>
            ) : (
              <li key={e.to} className={styles.item}>
                <Link className={styles.link} to={e.to}>
                  {e.title}
                </Link>
              </li>
            )
          )}
        </ul>
      ) : null}
    </div>
  );
}

function ImageBullets({ list, className }: Props) {
  return (
    <ul className={clsx(styles.container, className)}>
      {list.map((e, i) => (
        <li key={e.title} className={styles.tail}>
          <RenderItem idx={i} {...e} />
        </li>
      ))}
    </ul>
  );
}

export default ImageBullets;
